export const Debouncer = (() => {
    const timers = {};

    return {
        debounce(id, callback, delay = 2000) {
            if (timers[id]) {
                clearTimeout(timers[id].timeout);
            }

            const timeout = setTimeout(() => {
                callback();
                delete timers[id];
            }, delay);

            timers[id] = { timeout, callback };
        },

        cancel(id) {
            if (timers[id]) {
                clearTimeout(timers[id].timeout);
                delete timers[id];
            }
        },

        flush(id) {
            if (timers[id]) {
                clearTimeout(timers[id].timeout);
                const fn = timers[id].callback;
                delete timers[id];
                fn();
            }
        }
    };
})();

